function reveal() {
  var reveals = document.querySelectorAll('.reveal');
  var windowHeight, elementTop;

  for (var i=0; i < reveals.length; i++) {
    windowHeight = window.innerHeight;
    elementTop = reveals[i].getBoundingClientRect().top;

    if (elementTop < windowHeight/1.5) {
      reveals[i].classList.add('active');
    } else {
      reveals[i].classList.remove('active');
    }
  }
}

window.addEventListener('scroll', reveal);

